<template>
	<div id="modal-orders-sales-orders-edit-billing">
		<b-modal :id="modalName" title="Edit Product: " scrollable hide-footer>
            <template v-slot:modal-title>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <span>Edit Billing Address:</span>
                    <b-button 
                        variant="outline-secondary" 
                        size="sm" 
                        @click="copyAddress"
                        v-b-tooltip.hover title="Show formatted address for copying"
                    >
                        <i class="fas fa-copy"></i>
                    </b-button>
                </div>
            </template>

            <b-form v-if="billingAddress" @submit.stop.prevent="updateAddress">
                <b-form-group
                    id="input-group-address-1"
                    label="Address 1:"
                    label-for="input-address-1"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-address-1"
                        v-model="billingAddress.billing_address_1"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-address-2"
                    label="Address 2:"
                    label-for="input-address-2"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-address-2"
                        v-model="billingAddress.billing_address_2"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="input-group-city"
                            label="City:"
                            label-for="input-city"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-city"
                                v-model="billingAddress.billing_city"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-state"
                            label="State:"
                            label-for="input-state"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-state"
                                v-model="billingAddress.billing_state"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-zip"
                            label="Zip:"
                            label-for="input-zip"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-zip"
                                v-model="billingAddress.billing_postal_code"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-group
                    id="input-group-country"
                    label="Country:"
                    label-for="input-country"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-country"
                        v-model="billingAddress.billing_country"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'address'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-orders-sales-orders-edit-billing',
                billingAddress: [],
                submitting: 0,
                formattedAddress: ''
			}
		},

		methods: {
            updateAddress() {
                this.$emit('updateAddress', 'billing', this.billingAddress)
                this.closeModal(this.modalName)
            },

            copyAddress() {
                const address = this.formatAddressForCopy(this.billingAddress, 'billing')
                this.copyToClipboard(address)
            },

            formatAddressForCopy(address, type) {
                const lines = []
                
                // Address 1
                if (address[`${type}_address_1`]) {
                    lines.push(address[`${type}_address_1`])
                }
                
                // Address 2
                if (address[`${type}_address_2`]) {
                    lines.push(address[`${type}_address_2`])
                }
                
                // City, State, Zip
                const cityStateZip = []
                if (address[`${type}_city`]) {
                    cityStateZip.push(address[`${type}_city`])
                }
                if (address[`${type}_state`]) {
                    cityStateZip.push(address[`${type}_state`])
                }
                if (address[`${type}_postal_code`]) {
                    cityStateZip.push(address[`${type}_postal_code`])
                }
                
                if (cityStateZip.length > 0) {
                    lines.push(cityStateZip.join(', '))
                }
                
                // Country
                if (address[`${type}_country`]) {
                    lines.push(address[`${type}_country`])
                }
                
                return lines.join('\n')
            },

            // Copy method with proper fallback
            async copyToClipboard(text) {
                console.log('Attempting to copy:', text)
                
                // Check if Clipboard API is available
                if (navigator.clipboard && window.isSecureContext) {
                    try {
                        await navigator.clipboard.writeText(text)
                        console.log('✅ Clipboard API succeeded')
                        this.showSuccessToast('Address copied to clipboard!')
                        return
                    } catch (err) {
                        console.error('❌ Clipboard API failed:', err)
                    }
                }
                
                // Fallback to legacy method
                console.log('Using legacy copy method')
                try {
                    const textarea = document.createElement('textarea')
                    textarea.value = text
                    textarea.style.position = 'fixed'
                    textarea.style.top = '0'
                    textarea.style.left = '0'
                    textarea.style.width = '2em'
                    textarea.style.height = '2em'
                    textarea.style.padding = '0'
                    textarea.style.border = 'none'
                    textarea.style.outline = 'none'
                    textarea.style.boxShadow = 'none'
                    textarea.style.background = 'transparent'
                    
                    document.body.appendChild(textarea)
                    textarea.focus()
                    textarea.select()
                    
                    const successful = document.execCommand('copy')
                    document.body.removeChild(textarea)
                    
                    if (successful) {
                        console.log('✅ Legacy copy succeeded')
                        this.showSuccessToast('Address copied to clipboard!')
                    } else {
                        console.log('❌ Legacy copy failed')
                        this.showErrorToast('Copy failed. Please try again.')
                    }
                } catch (err) {
                    console.error('❌ Legacy copy failed:', err)
                    this.showErrorToast('Copy failed. Please try again.')
                }
            },


            showSuccessToast(message = 'Address copied to clipboard!') {
                this.$bvToast.toast(message, {
                    title: 'Success',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 3000
                })
            },

            showErrorToast(message = 'Failed to copy address. Please try again.') {
                this.$bvToast.toast(message, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                })
            }
		},

		computed: {

		},

		mounted() {
            this.billingAddress = Object.assign({}, this.address)
		}
	}
</script>
<style lang="scss">
    #modal-sales-orders-edit-billing {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
